
export function LogoTitleBlack() {
    return (
        <div className="w-full flex justify-center rounded-br-3xl max-md:py-14 md:hidden max-md:bg-black ">
            <img
                src="/unjabbed.png"
                alt="unjabbed-logo"
                className="w-64"
                width={632}
                height={192}
            />
        </div>
    );
}